/**
 * chat_widget/src/widget/ui/Feed.tsx
 */

import { type RefObject } from "react";
import { VehicleResults } from "./VehiclesList";
import agentAvatar from "../../assets/avatar.png";
import type { Msg } from "../types/messagesTypes.ts";
import { VehicleSheet } from "./VehicleSheet";

import LeadForm from "./LeadForm/index.tsx";
import type { FormActiveType, LeadFormProps } from "../types/formTypes.ts";
import Loading from "./Loading.tsx";
import { VehicleHighlights } from "./VehicleSheet/VehicleHighlights.tsx";
import { MessageBubble } from "./ChatBubble/MessageBubble.tsx";
import { QuestionBubble } from "./ChatBubble/QuestionBubble.tsx";
import YesOrNotBubble from "./ChatBubble/YesOrNotBubble.tsx";
import ChoiceBubble from "./ChatBubble/ChoiceBubble.tsx";
import MaxPriceBubble from "./ChatBubble/MaxPriceBubble.tsx";

export default function Feed({
  messages,
  lang,
  loading,
  bodyRef,
  onMoreInfo,
  onMoreInfoGarage,
  onBookTestDrive,
  getVehicleDetails,
  selectedCar,
  setSelectedCar,
  actions,
  onSend,
  refreshSession,
  attachedCar,
  clearAttachedCar,
  formActive,
  scrollToBottom,
  setFormActive,
  onBooked,
  avatar
}: {
  messages: Msg[];
  lang: string;
  avatar: string | null,
  loading: boolean;
  attachedCar: any;
  formActive: FormActiveType | null;
  bodyRef: RefObject<HTMLDivElement | null>;
  getVehicleDetails: (carId: string) => void;
  selectedCar: any;
  onMoreInfoGarage: () => void;
  onMoreInfo: (carId: string) => void;
  onBookTestDrive: (carId: string) => void;
  actions: [];
  setSelectedCar: React.Dispatch<React.SetStateAction<any>>;
  onSend: (date: string) => void;
  refreshSession: () => void;
  clearAttachedCar: () => void;
  scrollToBottom: () => void;
  setFormActive: (v: FormActiveType | null) => void;
  onBooked: LeadFormProps["onBooked"];
}) {
  return (
    <>
      {selectedCar && (
        <VehicleSheet
          v={selectedCar}
          lang={lang}
          setSelectedCar={setSelectedCar}
          onBookTestDrive={onBookTestDrive}
          onMoreInfo={onMoreInfo}
          actions={actions}
        />
      )}
      <div className="vcw-body" ref={bodyRef}>
        {messages.map((m, i) => {
          const key = `msg_${i}`;
          return (
            <div key={key} className="vcw-row-container">
              {m.intent !== "question" ? (
                <MessageBubble
                  role={m.role}
                  text={m.text}
                  agentAvatar={agentAvatar}
                  avatar={avatar}
                />
              ) : (
                <QuestionBubble text={m.text} onClick={() => onSend(m.text)} />
              )}

              {m.role === "assistant" &&
                Array.isArray((m as any).highlights) &&
                (m as any).highlights.length > 0 && (
                  <VehicleHighlights
                    highlights={(m as any).highlights}
                    getVehicleDetails={getVehicleDetails}
                  />
                )}

              {m.role === "assistant" &&
                Array.isArray(m.results) &&
                m.results.length > 0 && (
                  <VehicleResults
                    results={m.results}
                    msgIndex={i}
                    lang={lang}
                    getVehicleDetails={getVehicleDetails}
                  />
                )}

              {m.role === "assistant" && m.intent === "appointment_unknown" && (
                <YesOrNotBubble
                  actionYes={() => onMoreInfoGarage()}
                  actionNo={() => refreshSession()}
                />
              )}
              {m.role === "assistant" && m.step === "energie" && (
                <ChoiceBubble
                  onSend={onSend}
                  array={["Essence", "Diesel", "Électrique", "Hybride"]}
                />
              )}
              {m.role === "assistant" && m.step === "typeboite" && (
                <ChoiceBubble
                  onSend={onSend}
                  array={["Boite manuelle", "Boite auto"]}
                />
              )}
              {m.role === "assistant" && m.step === "price" && (
                <MaxPriceBubble onSend={onSend} />
              )}
              {m.role === "assistant" && m.intent === "need_infos_vehicle" && (
                <div className="vcw-additionnal-message-container">
                  <button
                    className="vcw-yes-btn"
                    onClick={() =>
                      onMoreInfo(selectedCar?._id || attachedCar?._id)
                    }
                  >
                    En savoir plus
                  </button>
                </div>
              )}
              {m.role === "assistant" &&
                m.intent === "need_more_infos_garage" && (
                  <div className="vcw-additionnal-message-container">
                    <button
                      className="vcw-yes-btn"
                      onClick={() =>
                        setFormActive({
                          name: "lead_more_infos_garage",
                          label: "Un vendeur peut vous rappeler !",
                        })
                      }
                    >
                      En savoir plus
                    </button>
                  </div>
                )}
              {m.role === "assistant" &&
                m.intent === "need_more_infos_trade_in" && (
                  <div className="vcw-additionnal-message-container">
                    <button
                      className="vcw-yes-btn"
                      onClick={() =>
                        setFormActive({
                          name: "lead_garage_trade_in",
                          label: "Votre reprise !",
                        })
                      }
                    >
                      En savoir plus
                    </button>
                  </div>
                )}
            </div>
          );
        })}
        {formActive && (
          <LeadForm
            onBooked={onBooked}
            formActive={formActive}
            clearAttachedCar={clearAttachedCar}
            scrollToBottom={scrollToBottom}
            setFormActive={setFormActive}
            refreshSession={refreshSession}
          />
        )}
        {loading && <Loading />}
      </div>
    </>
  );
}
